import { useContext } from 'react'
import { ConfirmActionContext } from 'src/context/ConfirmActionContext'

export const useConfirmationDialog = () => useContext(ConfirmActionContext)
